const urlParams = new URLSearchParams(window.location.search);
const metalSelect = document.getElementById("metal-select");
const ringSizeSelect = document.getElementById("ring-size-select");
const caratSizeSelect = document.getElementById("carat-select");
const metalKeys = '10k-white-gold,10k-rose-gold,10k-yellow-gold,14k-white-gold,14k-rose-gold,14k-yellow-gold,18k-white-gold,18k-rose-gold,18k-yellow-gold,solid-platinum';

const pristineParadigmApi = 'https://pristine-paradigm-emf9csbee2fyf2d9.southeastasia-01.azurewebsites.net';
let isMoissanite = false;
let productDetails = {};
let metalVariants = [];
let selectedMetalRingVariantId = "";
let selectedMetalRing = {};
let stringBirthstone = "";
let selectedDiamond = {};
let isDiamondSelect = false;
let productImages = [];
let filteredImages = [];

window.selectedMetalRing = selectedMetalRing;
window.selectedMetalRingVariantId = selectedMetalRingVariantId;
document.addEventListener("DOMContentLoaded", function () {

  const redirectDiv = document.getElementById("redirectDiv");
  if(redirectDiv){
    console.log("GETTING PARENT ID");
    getParentId();
    return;
  }
  
  metalSelect.addEventListener("change", fetchCorrectVariant);
  ringSizeSelect.addEventListener("change", fetchCorrectVariant);
  if(caratSizeSelect){
    caratSizeSelect.addEventListener("change", fetchCorrectVariant);
  }
  
  function renderDiamondSelector() {

    const urlParams = new URLSearchParams(window.location.search);
    isDiamondSelect = window.location.href.includes("isDiamondSelect=true");
    const diamondSelector = document.getElementById("diamond-selection-button");

    let innerHtmlToAdd = ""; // ✅ Change `const` to `let` to allow reassignment
    let selectedDiamondJSON = sessionStorage.getItem("selectedDiamond");
    let selectDiamondData = JSON.parse(selectedDiamondJSON);
    
    // Debug logging
    console.log("isDiamondSelect:", isDiamondSelect);
    console.log("selectedDiamondJSON:", selectedDiamondJSON);
    console.log("selectDiamondData:", selectDiamondData);
    
    loadSelectedCurrentRingDetails_METALRING();
    if (selectDiamondData) {
      console.log("Diamond data found, calling textBoxDiamondSelected()");
      innerHtmlToAdd = textBoxDiamondSelected();
      console.log("innerHtmlToAdd:", innerHtmlToAdd);
    } else {
      console.log("No diamond data found, showing select button");
      if(diamondSelector){
      innerHtmlToAdd = `<button
      id="select-diamond-button"
      type="button"
      class="mt-3 inline-flex items-center justify-center w-full focus:outline-none"
      style="padding: 14px 22px; margin-top: 12px; background-color: #1C3C35 !important; color: #FFFFFF !important; border: 1px solid #1C3C35 !important;">
      Select Your Pristine Lab Diamond Here
      </button>
      `;
      }
      selectShape("emerald");

    }
    console.log("diamondSelector:", diamondSelector);
    console.log("innerHtmlToAdd:", innerHtmlToAdd);
    if(innerHtmlToAdd != ""){
      console.log("Setting innerHTML to diamond selector");
      diamondSelector.innerHTML = innerHtmlToAdd; // ✅ Corrected assignment
    } else {
      console.log("innerHtmlToAdd is empty, not setting innerHTML");
    }
    
    // Update button state after rendering diamond selector
    if (typeof updateButtonState === 'function') {
      updateButtonState();
    }
  }

  function textBoxDiamondSelected() {
    const classForTextbox = `py-2 px-3 sm:py-3 sm:px-4 block lg:w-full bg-gray-100 border-transparent sm:text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:border-transparent dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600`;

    let selectedDiamondJSON = sessionStorage.getItem("selectedDiamond");
    let selectDiamondData = JSON.parse(selectedDiamondJSON);
    selectedDiamond = selectDiamondData;
    window.updateTotalPrice();
    
    // Update button state when diamond is selected
    if (typeof window.updateButtonState === 'function') {
      window.updateButtonState();
    }

    return `<div class="w-full mt-3 p-3 flex flex-row border border-gray-200 rounded-xl shadow-sm bg-white space-y-2">
            
            <div class="flex flex-1 flex-col">
              <div class="flex flex-col gap-1">
                <h4 class="text-lg font-semibold text-gray-800">Center Diamond</h4>
                <p class="text-sm text-gray-600">
                  ${selectDiamondData.shape} ${selectDiamondData.weight}ct Lab Grown Diamond,
                  ${selectDiamondData.color}, ${selectDiamondData.clarity}
                </p>
                <p class="text-sm text-gray-600">
                  ${selectDiamondData.lab} certificate: <span class="font-medium">${selectDiamondData.certificate}</span>
                </p>
                <p class="text-base font-semibold text-gray-800">
                  ₱${selectDiamondData.finalAmount.toLocaleString('en-PH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
                </p>
              </div>
              <div>
                <button id="select-diamond-button"
                  class="mt-2 inline-block text-sm px-4 py-2 rounded-xl bg-purple-700 text-white hover:bg-purple-800 transition">
                  Change
                </button>
              </div>
            </div>
            <div class="flex w-1/4">
              <div class="p-1">
                <img src="${selectDiamondData.diamondImage}" alt="Diamond" class="diamond-image">
              </div>  
            </div>
          </div>
          `;
  }

  getMetalRingDetails()
  renderDiamondSelector();

  // watchVariantChange(); // Run watcher on page load
  
  // Add event listener for diamond selection changes
  document.addEventListener('click', function(e) {
    if (e.target && e.target.id === 'select-diamond-button') {
      // When "Change" button is clicked, update button state after a short delay
      setTimeout(() => {
        if (typeof updateButtonState === 'function') {
          updateButtonState();
        }
      }, 100);
    }
  });
});


function loadSelectedCurrentRingDetails_METALRING() {
  const details = sessionStorage.getItem("selectedCurrentRingDetails");
  if (!details) return;

  const ringData = JSON.parse(details);

  // ✅ Set the dropdown values
  document.getElementById("metal-select").value = ringData.metal;
  document.getElementById("ring-size-select").value = ringData.ringSize;
  selectShape(ringData.shape);
}

function getMetalRingDetails() {
  const productId = meta.product.id;
  const gid = "gid://shopify/Product/" + productId;
  const url = pristineParadigmApi + "/api/product/moissanite/get/gid";

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify("gid://shopify/Product/" + meta.product.id)
  })
    .then(response => response.json())
    .then(data => {
      productDetails = data;
      if(data){
        if(data.moissaniteImages){
          productImages = data.moissaniteImages;
         }
        fetchCorrectVariant();
        // Update add-to-cart button state based on moissanite flag
        if (typeof updateButtonState === 'function') {
          // Expose to window so other scripts can read it
          window.productDetails = productDetails;
          updateButtonState();
        }
      }
    })
    .catch(error => {
      console.error("Fetch error:", error);
    });
}

function normalizeMetalString(str) {
  if (!str) return '';
  return str.toLowerCase()
    .replace(/-/g, ' ')
    .replace(/[^\w\s]/g, '')
    .trim();
}

function getRoundedRingSize(size) {
  const n = parseFloat(size);
  if (Number.isNaN(n)) return n;
  return Number.isInteger(n) ? n : Math.ceil(n);
}

// ✅ REDIRECT FUNCTION WHEN METAL CHANGES
function fetchCorrectVariant() {
  if (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  const metalSelect = document.getElementById("metal-select");
  const ringSizeSelect = document.getElementById("ring-size-select");

  const selectedMetal = metalSelect?.value;
  const selectedSize = ringSizeSelect?.value;
  let selectedCarat = 0.5;
  let rangedCarat = 0.5;
  if (!selectedMetal || !selectedSize) return;

  isMoissanite = productDetails.isMoissanite;
  if (isMoissanite) {
    const caratSizeSelect = document.getElementById("carat-select");
    selectedCarat = caratSizeSelect?.value;
    rangedCarat = getCaratCategory(selectedCarat);
  } else if (isDiamondSelect) {
    const caratDiamondWeight = selectedDiamond.weight;
    rangedCarat = getCaratCategory(caratDiamondWeight);
  }

  const matchRingSize = getRoundedRingSize(selectedSize);
  const isNextSize = matchRingSize > 7.5;

  const matchedMetalType = productDetails.moissaniteMetalTypes.find((v) => {
    const normalizedSelectedMetal = normalizeMetalString(selectedMetal);
    const normalizedMetalType = normalizeMetalString(v.metalType);
    const normalizedName = normalizeMetalString(v.name);
    const selectedMetalNormalized = selectedMetal?.toLowerCase().replace(/-/g, ' ');

    const metalMatch =
      normalizedMetalType === normalizedSelectedMetal ||
      normalizedName.includes(normalizedSelectedMetal) ||
      normalizedName.includes(selectedMetalNormalized) ||
      v.name?.toLowerCase().replace(/-/g, ' ').includes(selectedMetalNormalized);

    let nextSizeMatch;
    if (v.isNextSize !== undefined) {
      nextSizeMatch = v.isNextSize === isNextSize;
    } else {
      nextSizeMatch = isNextSize ? v.name?.endsWith(".") : !v.name?.endsWith(".");
    }

    return metalMatch && nextSizeMatch;
  });

  if (matchedMetalType) {
    const matched = matchedMetalType.moissaniteVariants.find(
      (v) => Number(v.carat) === Number(rangedCarat) && Number(v.ringSize) === matchRingSize
    );

    if (matched) {
      if (productImages.length > 0) {
        const lowerMetal = selectedMetal.toLowerCase();
        let code = '';

        if (lowerMetal.includes('white gold')) {
          code = 'WG';
        } else if (lowerMetal.includes('rose gold')) {
          code = 'RG';
        } else if (lowerMetal.includes('yellow gold')) {
          code = 'YG';
        }

        const shapeFilter = selectedMetalRingShape || '';
        const combinedCode = `${shapeFilter}-${code}`;
        const normalizedCombinedCode = combinedCode.toLowerCase().replace(/\s+/g, '');

        filteredImages = code
          ? productImages.filter(img => {
              const normalizedFileName = img.fileName.toLowerCase().replace(/\s+/g, '');
              return normalizedFileName.includes(normalizedCombinedCode);
            })
          : productImages;

        const sortedImages = filteredImages.sort((a, b) => {
          const nameA = a.fileName.toLowerCase();
          const nameB = b.fileName.toLowerCase();
          return nameA.localeCompare(nameB);
        });

        injectAzureImagesIntoGallery(sortedImages);
        console.warn("filtered images", combinedCode, filteredImages);
      }

      selectedMetalRingVariantId = matched.shopifyVariantId;
      selectedMetalRing = matched;
      window.selectedMetalRing = matched;
      window.selectedMetalRingVariantId = matched.shopifyVariantId;
      console.log("MATCHED PRICE", matched);
      window.updateTotalPrice();
    } else {
      console.warn("❌ No variant match for", rangedCarat, matchRingSize, "(selected:", selectedSize, ")");
      console.warn("Matched Metal Type", matchedMetalType);
    }
  } else {
    console.warn("❌ No metal Type match for", selectedMetal, isNextSize);
  }
}

function getCaratCategory(carat) {
  if (carat >= 0.5 && carat <= 0.7) return 0.5;
  if (carat > 0.7 && carat <= 1.19) return 1;
  if (carat > 1.19 && carat <= 1.7) return 1.5;
  if (carat > 1.7 && carat <= 2.19) return 2;
  if (carat > 2.19 && carat <= 2.7) return 2.5;
  if (carat > 2.7 && carat <= 3.19) return 3;
  if (carat > 3.19 && carat <= 3.7) return 3.5;
  if (carat > 3.7 && carat <= 4.19) return 4;
  if (carat > 4.19 && carat <= 4.7) return 4.5;
  if (carat > 4.7 && carat <= 5.19) return 5;
  return 0.5;
}

function injectAzureImagesIntoGallery(imageList) {
  const gallery = document.getElementById('external-product-gallery');
  if (!gallery || !imageList.length) return;

  // Clear default content if needed
  gallery.innerHTML = '';

  const scrollCarousel = document.createElement('scroll-carousel');
  scrollCarousel.className = 'product-gallery__carousel scroll-area full-bleed md:unbleed relative';
  scrollCarousel.setAttribute('role', 'region');
  scrollCarousel.setAttribute('id', 'custom-gallery-carousel');

  imageList.forEach((image, index) => {
    const mediaDiv = document.createElement('div');
    mediaDiv.className = 'product-gallery__media snap-center';
    mediaDiv.setAttribute('data-media-type', 'image');
    mediaDiv.setAttribute('aria-label', `Image ${index + 1}`);
    mediaDiv.setAttribute('role', 'group');

    const img = document.createElement('img');
    img.src = image.url;
    img.alt = `Moissanite image ${index + 1}`;
    img.className = 'object-contain w-full h-auto';

    mediaDiv.appendChild(img);
    scrollCarousel.appendChild(mediaDiv);
  });

  gallery.appendChild(scrollCarousel);

  // Add product disclaimer
  // const disclaimerDiv = document.createElement('div');
  // disclaimerDiv.className = 'product-gallery__disclaimer absolute bottom-2 left-2 right-2 md:top-2 md:bottom-auto md:left-2 md:right-2 p-2 bg-white/90 backdrop-blur-sm border border-neutral-200 rounded shadow-sm';
  // disclaimerDiv.style.zIndex = '10';
  
  // const disclaimerText = document.createElement('p');
  // disclaimerText.className = 'text-[10px] text-neutral-600 text-center italic leading-tight';
  // disclaimerText.textContent = 'Images are for illustration only and show a 2 CT center stone. Actual appearance may vary based on carat weight, cut, and other details.';
  
  // disclaimerDiv.appendChild(disclaimerText);
  // gallery.appendChild(disclaimerDiv);
}

function scrollCarousel(direction) {
  const carousel = document.getElementById('shapeCarousel');
  const scrollAmount = 150;
  carousel.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
}

function getParentId(productId){
  var productCurrentId = meta.product.id;
  const gid = "gid://shopify/Product/" + productCurrentId;
  const url = pristineParadigmApi + "/api/product/moissanite/get/parentId";

  fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify("gid://shopify/Product/" + meta.product.id)
})
  .then(response => response.text()) // <- extract the response body as text
  .then(data => {
    const value = String(data).toLowerCase();

    if (value === "nothing found") {
      return;
    }

    const urlRedirect = encodeURI(data); // encode in case of special characters
    const redirectDivider = document.getElementById("redirectDiv");

    redirectDivider.innerHTML = `
      <p style="font-size: 14px; color: #333;">
        When changing your ring size or metal, please remove the previous item from your cart.
        Then, click <a href="${urlRedirect}" style="text-decoration: underline; color: #007BFF;">here</a> 
        to return to the main product page.
      </p>
    `;

  })
  .catch(error => {
    console.error("Fetch error:", error);
  });

}

// Price update functions
function getCheckedBirthstones() {
  const selected = [];
  const checkboxes = document.querySelectorAll('input[name="birthStones[]"]:checked');

  checkboxes.forEach(cb => {
    selected.push({
      variantId: cb.value,
      name: cb.getAttribute('data-name'),
      price: 600
    });
  });

  return selected;
}

window.updateTotalPrice = function() {
  const metalRing = window.selectedMetalRing || selectedMetalRing || {};
  let totalAmountCartPrice = metalRing?.price || 0;

  let isMoissaniteWND = window.productDetails?.isMoissanite || false;
  
  let checkboxes = getCheckedBirthstones();
  checkboxes.forEach(cb => {
    totalAmountCartPrice += 600;
  });
  
  if(selectedDiamond?.finalAmount > 0 && !isMoissaniteWND){
    totalAmountCartPrice += selectedDiamond.finalAmount
  }

  updateBuyButtonLabel(totalAmountCartPrice);
  changePriceValue(metalRing?.price || 0);
  console.log("WINDOW UPDATE TOTAL P{RICE", totalAmountCartPrice);
}

function updateBuyButtonLabel(totalPrice) {
  const button = document.getElementById("AddToCartButton");
  if (button) {
    const selectedDiamondJSON = sessionStorage.getItem("selectedDiamond");
    const hasDiamondSelected = selectedDiamondJSON && selectedDiamondJSON !== "null" && selectedDiamondJSON !== "undefined";
    
    if (!hasDiamondSelected) {
      return;
    }
    
    if (totalPrice == 0) {
      button.textContent = "Add Custom Ring to Cart";
    } else {
      button.textContent = `Add Custom Ring to Cart — ₱${totalPrice.toLocaleString('en-PH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}`;
    }
    console.log("Add to car button loaded", totalPrice);
  }
}

function changePriceValue(newPrice) {
  const moneySpans = document.querySelectorAll('.price-list .money');
  const price = newPrice || 0;

  moneySpans.forEach(span => {
    span.textContent = `₱${price.toLocaleString('en-PH', { minimumFractionDigits: 2 })}`;
  });
}

